import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '@/helpers/utils';
import {
  useIsLoungeOpen,
  useLoungeById,
} from '@/hooks/loungesHooks/loungesHelperHooks';
import { getLoungeOpenTimesForTodayAsString } from '@/helpers/loungeHelper';
import { useRouteParams } from '@/context/routeParamsContext';
import {
  useCommonContent,
  useOneCmsLocaleDateFormattingObj,
} from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';

const LoungeOpenStatusText = ({ className }) => {
  const {
    lounges: { open: openLabel, closed: closedLabel, closesAt },
  } = useCommonContent();
  const { loungeId } = useRouteParams();
  const lounge = useLoungeById(loungeId);
  const isLoungeOpen = useIsLoungeOpen(loungeId);
  const format = useOneCmsLocaleDateFormattingObj();
  // locale always en-US so day of the week is in english to match the api lounge hours response
  const hoursForToday = getLoungeOpenTimesForTodayAsString(
    'en-US',
    lounge,
    format.timeFormat
  );
  const closingTime = hoursForToday?.split(' - ')?.[1];

  if (isLoungeOpen === null) {
    return null;
  }

  return (
    <div className={cn(className, 'flex-row')}>
      {isLoungeOpen === null ? null : isLoungeOpen ? (
        <>
          <span
            className={cn(
              className,
              'heading-sans-xsmall-bold sans-xsmall-bold tw-capitalize tw-text-status-success-important'
            )}
          >
            {openLabel.toLocaleLowerCase()}
          </span>
          {closingTime ? (
            <span className="tw-font-normal">
              &nbsp;• {closesAt} {closingTime}
            </span>
          ) : null}
        </>
      ) : (
        <span className="tw-capitalize tw-text-status-caution-important">
          {closedLabel.toLocaleLowerCase()}
        </span>
      )}
    </div>
  );
};

LoungeOpenStatusText.defaultProps = {
  className: '',
};

LoungeOpenStatusText.propTypes = {
  className: PropTypes.string,
};

export default LoungeOpenStatusText;
